import React from 'react'
import PropTypes from 'prop-types'
import styles from './PageLayout.module.scss'

const PageLayout = ({ children, className }) => (
  <div className={`${styles.root}${className ? ` ${className}` : ''}`}>
    {children}
  </div>
)

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

export default PageLayout
